module.exports = __webpack_public_path__ + "img/com.9b06043d.svg";